import { compose, equals, prop, propOr } from 'ramda';

import { COMPANY } from 'constants/general';

import { NAME } from './constants';

export const getAppContext = (state) => state[NAME];

export const getOriginalUserLogin = compose(
	(val) => val.toLocaleLowerCase(),
	propOr('', 'originalUserLogin'),
	getAppContext,
);

export const getToken = compose(prop('accessToken'), getAppContext);

export const getRefreshToken = compose(prop('refreshToken'), getAppContext);

export const getOriginalFirstName = compose(prop('originalFirstName'), getAppContext);

export const getOriginalSurname = compose(prop('originalSurname'), getAppContext);

export const getBackendUrl = compose(prop('backendUrl'), getAppContext);

export const getCompanyId = compose(Number, prop('companyId'), getAppContext);

export const isCp = compose(equals(COMPANY.CP), getCompanyId);

export const isGli = compose(equals(COMPANY.GLI), getCompanyId);

export const getTargetPage = compose(prop('targetPage'), getAppContext);
